import { Box, Typography } from '@mui/material';

import { wf } from './tokens';

export function IntakePageHeader({ title, sub }: { title: string; sub?: string }) {
  return (
    <Box>
      <Typography component="h1" sx={{ fontSize: '19px', fontWeight: 700, margin: 0 }}>
        {title}
      </Typography>
      {sub && (
        <Typography sx={{ fontSize: '13px', color: wf.muted, margin: '4px 0 0' }}>{sub}</Typography>
      )}
    </Box>
  );
}
